module.exports = __webpack_public_path__ + "assets/seatbelt_unbuckled.df2ccbc9.svg";